import { forwardRef } from "react";
import type { InputProps } from "@/components/ui/input";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
  InputGroupText,
} from "@/components/ui/input-group";

export interface MoneyInputProps extends Omit<InputProps, "unstyled"> {
  currencySymbol?: string;
  containerClassName?: string;
}

/** Keeps the currency suffix outside the editable numeric value. */
export const MoneyInput = forwardRef<HTMLInputElement, MoneyInputProps>(function MoneyInput(
  { currencySymbol = "$", containerClassName, size = "sm", ...props },
  ref,
) {
  return (
    <InputGroup className={containerClassName}>
      <InputGroupInput ref={ref} inputMode="decimal" size={size} {...props} />
      <InputGroupAddon align="inline-end">
        <InputGroupText>{currencySymbol}</InputGroupText>
      </InputGroupAddon>
    </InputGroup>
  );
});
